import { cn } from "@/lib/utils";

export const SolutionsMobileSecond = () => {
    return (
        <div className="w-[full] px-[10px]">
            <Item
                id="remote-office"
                title="SD-WAN远程办公"
                imgsrc="/imgs/solutions/1.png"
            >
                <div>
                    <div className=" font-medium text-[12px] text-[#333333]">
                        SD-WAN远程办公，纯软件部署方案
                    </div>
                    <div className=" font-light text-[12px] text-[#333333] mt-[6px]">
                        基于SD-WAN智能组网方案，通过组建异地虚拟局域网,实现异地局域网内电脑、手机、服务器的互联互通，为个人及企业用户提供远程办公支持。
                    </div>
                </div>
            </Item>
            <Item
                id="smart-security"
                title="智慧安防解决方案"
                pageClassName="bg-gradient-to-b from-white via-[#E8F3FF] to-white"
                // className="flex-row-reverse"
                imgsrc="/imgs/solutions/2.png"
            >
                <div>
                    <ItemTitle title="方案部署" />
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        安防监控中心与各安防监控点均部署一台光年K-WAN
                        CPE路由器基于”SD-WAN+物联网”智能组网网络架构，通过云平台将多地的路由器组建成一
                        个大型虚拟局域网
                        安防监控中心视频资源平台可集中管理所有视频监控，在内网随时查看全城视频监
                        控。
                    </div>
                    <ItemTitle title="方案优点" />
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        <div className="flex  gap-[2px]">
                            <div className="text-[#003366] min-w-[100px] block">
                                兼容性强:兼容不同运营商网络，联网即用
                            </div>
                        </div>
                        <div className="flex items-start  gap-[2px]">
                            <div className="text-[#003366] min-w-[100px]">部署灵活: 不改变原有网络结构，弹性管理新增的安防监控点</div>
                        </div>
                        <div className="flex items-start gap-[2px]">
                            <div className="text-[#003366] min-w-[100px]">数据安全: 通过云虚拟局域网技术提供安全隧道，保证视频资源传输安全</div>
                        </div>
                    </div>
                </div>
            </Item>
            <Item
                id="it-internet"
                title="IT互联网解决方案"
                imgsrc="/imgs/solutions/3.png"
            >
                <div>
                    <ItemTitle title="方案部署" />
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        1、企业总部与各分支、子公司等地均部署光年K-WANCPE路由器，个人外出使用可安装光年无界客户端软件
                    </div>
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        2、以“打造互联网规范化管理平台”为核心目标，通过云平台将多地的路由器组建成个大型虚拟局域网
                    </div>
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        3、结合OA办公、ERP、NAS、FTP服务器等等，实现跨地域、跨网络、跨系统的互联互通，为IT互联网业务提供一个强大的管理支撑平台
                    </div>
                    <ItemTitle title="方案优点" />
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        <div>
                            <div className="text-[#003366] min-w-[100px]">兼容性强: 建立互联互通的统一管理平台，各分支多系统共同协作</div>
                        </div>
                        <div>
                            <div className="text-[#003366] min-w-[100px]">远程维护: 随时随地远程连接，简约工作流程，降低时间成本</div>
                        </div>
                        <div className="text-[#003366] min-w-[100px]">数据安全: 企业内部信息数据传输、存储时加密处理</div>
                    </div>
                </div>
            </Item>
            <Item
                id="smart-manufacture"
                title="智能制造解决方案"
                imgsrc="/imgs/solutions/4.png"
                pageClassName="bg-gradient-to-b from-white via-[#E8F3FF] to-white"

            >
                <div>
                    <ItemTitle title="方案部署" />
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        1、工厂总部与各个分厂、生产物料仓库等地均部署光年K-WAN CPE路由器
                    </div>
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        2、以”建立强大的生产信息链”为目标，通过云平台将多地的路由器组建成一个大型虚拟局域网
                    </div>
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        3、结合现有的制造信息系统，为不同区域的制造工厂搭建灵活、高效、弹性可扩展的生产管理信息化平台
                    </div>
                    <ItemTitle title="方案优点" />
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        <div>
                            <div className="text-[#003366] min-w-[100px]">兼容性强: 兼容不同运营商网络，联网即用</div>
                        </div>
                        <div>
                            <div className="text-[#003366] min-w-[100px]">远程维护: 自建管理中心独立管理、弹性部署与管理新增工厂的网络</div>
                        </div>
                        <div className="text-[#003366] min-w-[100px]">数据共享: 海量设备数据实时上传，存储，处理，集中管理</div>
                    </div>
                </div>
            </Item>
            <Item
                id="smart-traffic"
                title="智能交通解决方案"
                imgsrc="/imgs/solutions/5.png"
            >
                <div>
                    <ItemTitle title="方案部署" />
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        1、安防监控中心与各安防监控点均部署一台光年K-WAN CPE路由器
                    </div>
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        2、以“实时监测+智能调度运营”为核心，通过云平台将多地的路由器组建成一个大型
                        虚拟局域网
                    </div>
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        3、结合视频监控管理系统、车载客流统计系统、车辆调度运营管理系统等系统，打造
                        监测、调度运营、车辆动态跟踪的交通信息管理体系
                    </div>
                    <ItemTitle title="方案优点" />
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        <div>
                            <div className="text-[#003366] min-w-[100px]">部署灵活: 弹性管理新增的交通点，远程维护</div>
                        </div>
                        <div>
                            <div className="text-[#003366] min-w-[100px]">数据安全: 交通信息数据传输、存储时加密处理成本较低:方案实施成本低、周期短，管理维护成本低</div>
                        </div>
                    </div>
                </div>
            </Item>
            <Item
                id="smart-medical"
                title="智慧医疗解决方案"
                pageClassName="bg-gradient-to-b from-white via-[#E8F3FF] to-white"
                imgsrc="/imgs/solutions/6.png"
            >
                <div>
                    <ItemTitle title="方案部署" />
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        1、医院总部与各地医疗分支、体检中心、医疗固定资产中心、病房等地均部署光年K-WAN路由器
                    </div>
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        2、以”打造医疗大数据信息集成平台”为目标，通过云平台将多地的路由器组建成一个
                        大型虚拟局域网
                    </div>
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        3、结合体检、诊断、治疗、辅助等多类医疗设备，实现患者与医务人员、医疗机构、
                        医疗设备之间的互动，逐步达到全面信息化
                    </div>
                    <ItemTitle title="方案优点" />
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        <div>
                            <div className="text-[#003366] min-w-[100px]">远程连接: 线上预约数据及时回传医院，合理分配资源远程会诊</div>
                        </div>
                        <div>
                            <div className="text-[#003366] min-w-[100px]">统一管理: 将各医疗软件系统的数据采集汇聚，建立医疗大数据平台</div>
                        </div>
                        <div className="text-[#003366] min-w-[100px]">数据安全: 医疗信息数据传输、存储时加密处理</div>
                    </div>
                </div>
            </Item>
            <Item
                id="retail-chain"
                title="零售连锁解决方案"
                imgsrc="/imgs/solutions/7.png"
            >
                <div>
                    <ItemTitle title="方案部署" />
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        1、零售总部与各连锁门店、商品仓库、供应商等地均部署一台光年K-WAN
                        CPE路由器
                    </div>
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        2、以“打造智慧新零售”为目标，通过云平台将多地的路由器组建成一个大型虚拟局域网
                    </div>
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        3、结合收银系统、视频监控系统、进销存等系统，升级门店运营式，打通线上线下，实现信息化管理并提高门店工作效率
                    </div>
                    <ItemTitle title="方案优点" />
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        <div>
                            <div className="text-[#003366] min-w-[100px]">部署灵活: 新增的连锁门店连接互联网即可加入组网</div>
                        </div>
                        <div>
                            <div className="text-[#003366] min-w-[100px]">数据共享: 商品热销指数、库存数量等信息多门店共享</div>
                        </div>
                        <div className="text-[#003366] min-w-[100px]">成本较低: 管理维护多门店，无需到现场，实施成本低</div>
                    </div>
                </div>
            </Item>
            <Item
                id="smart-hotel"
                title="智慧酒店解决方案"
                imgsrc="/imgs/solutions/8.png"
                pageClassName="bg-gradient-to-b from-white via-[#E8F3FF] to-white"
            >
                <div>
                    <ItemTitle title="方案部署" />
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        1、酒店总部与各连锁酒店等地均部署光年K-WAN CPE路由器
                    </div>
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        2、以”打造网上销售平台与酒店信息管理中心”为目标，通过云平台将多地的路由器组
                        建成一个大型虚拟局域网
                    </div>
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        3、结合OA办公，收银，灯光设备控制、客房外等公共区域的视频监控等系统实现酒
                        店智能化、信息化
                    </div>
                    <ItemTitle title="方案优点" />
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        <div>
                            <div className="text-[#003366] min-w-[100px]">兼容性强: 兼容不同运营商网络，联网即用</div>
                        </div>
                        <div>
                            <div className="text-[#003366] min-w-[100px]">统一管理: 将各连锁酒店的多类控制系统、收银系统，监控系统等信息汇总，建立酒店信息管理中心</div>
                        </div>
                        <div className="text-[#003366] min-w-[100px]">数据安全: 通过云虚拟局域网技术提供安全隧道，保证视频等信息资源传输安全</div>
                    </div>
                </div>
            </Item>
            <Item
                id="smart-education"
                title="智慧教育解决方案"
                imgsrc="/imgs/solutions/9.png"
            >
                <div>
                    <ItemTitle title="方案部署" />
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        1、各高校本部与各分校区、信息网络中心、多媒体教学中心等地均部署光年K-WAN
                        CPE路由器
                    </div>
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        2、以“物联网””大数据“为技术基础，通过云平台将多地的路由器组建成一个大型虚拟
                        局域网
                    </div>
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        3、结合教务管理、OA办公、校园安防等系统，实现人、物、校区功能系统之间无缝连接，提供信息化教务管理服务
                    </div>
                    <ItemTitle title="方案优点" />
                    <div className=" font-light text-[10px] text-[#333333] mt-[6px]">
                        <div>
                            <div className="text-[#003366] min-w-[100px]">资源共享: 实现教育基础数据的有序开放与共享</div>
                        </div>
                        <div>
                            <div className="text-[#003366] min-w-[100px]">远程维护: 简约工作流程，提高工作效率</div>
                        </div>
                        <div className="text-[#003366] min-w-[100px]">统一管理: 建立互联互通的统一管理平台，多教育平台协同发展</div>
                    </div>
                </div>
            </Item>
        </div>
    );
};


const Item = ({
    children,
    title,
    className,
    imgsrc,
    pageClassName,
    id,
}: {
    children: React.ReactNode;
    title: string;
    className?: string;
    imgsrc?: string;
    pageClassName?: string;
    id?: string;
}) => {
    return (
        <div id={id} className={cn("", pageClassName)}>
            {/* <PageTitle title={title} /> */}
            <div className="text-center text-[18px] font-bold text-[rgba(51,51,51,1)]">{title}</div>
            <div
                className={cn(
                    "flex flex-col justify-between items-center mt-[10px]",
                    className
                )}
            >
                {children}
                <img
                    className="w-full h-[206px] mt-[14px]"
                    src={imgsrc}
                />

            </div>
            <div className="my-[30px] px-[30px]">
                <div
                    className="h-[2px]"
                    style={{
                        backgroundImage:
                            "linear-gradient(90deg, #FFFFFF 0%, #1FB4EE 30.77%, #0076FD 68.27%, #FFFFFF 100%)",
                    }}
                ></div>
            </div>
        </div>
    );
};

const ItemTitle = ({ title }: { title: string }) => {
    return (
        <div
            className=" font-medium text-[17px] text-left"
            style={{
                fontStyle: "normal",
                textTransform: "none",
                backgroundImage: "linear-gradient(0deg, #3172F2 0%, #00A6FF 100%)",
                WebkitBackgroundClip: "text",
                backgroundClip: "text",
                color: "transparent",
            }}
        >
            {title}
        </div>
    );
};
